import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import { WhatsAppButton } from "@/components/WhatsAppButton";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Leasing from "@/pages/Leasing";
import Sales from "@/pages/Sales";
import PropertyDetail from "@/pages/PropertyDetail";
import Contact from "@/pages/Contact";
import BookAppointment from "@/pages/BookAppointment";
import Brochure from "@/pages/Brochure";
import Admin from "@/pages/Admin";

const Layout = ({ children }) => {
  const location = useLocation();
  const hideChrome = location.pathname === "/brochure" || location.pathname.startsWith("/admin");
  return (
    <>
      {!hideChrome && <Navbar />}
      <main className="min-h-[60vh]">{children}</main>
      {!hideChrome && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/leasing" element={<Leasing />} />
            <Route path="/sales" element={<Sales />} />
            <Route path="/property/:id" element={<PropertyDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book-appointment" element={<BookAppointment />} />
            <Route path="/brochure" element={<Brochure />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Layout>
        <WhatsAppButton />
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
